export const SETTINGS_DISPLAY_MODE_DEFAULT = 'default';
export const SETTINGS_DISPLAY_MODE_BRANDS = 'brands';
export const SETTINGS_DISPLAY_MODE_DEFAULT_TITLE = 'Settings';
export const SETTINGS_DISPLAY_MODE_BRANDS_TITLE = 'Brands';
export const SETTINGS_DISPLAY_MODES = {
    [SETTINGS_DISPLAY_MODE_DEFAULT]: {
        title: SETTINGS_DISPLAY_MODE_DEFAULT_TITLE
    },
    [SETTINGS_DISPLAY_MODE_BRANDS]: {
        title: SETTINGS_DISPLAY_MODE_BRANDS_TITLE
    }
};
